// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3aOkH","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3e92Q"};